/**
 * Permission Dedup Pairs - Auto-generated from Go source
 *
 * DO NOT EDIT - This file is auto-generated by magefiles/internal/gen/gen.go
 * Source: pkg/permissions/dedup.go
 *
 * Each pair defines an implication: holding the "modify" permission implies holding the "read"
 * permission. The frontend uses these pairs to expand, dedup, and disable implied permissions
 * in the UI. Order matters for transitive resolution (e.g., AIRunAsModify → RunPantherAI → ViewAISkills).
 *
 * To add a new pair:
 *   1. Add the entry to dedupPairs in pkg/permissions/dedup.go
 *   2. Run 'mage gen:permissionDedupPairs' to regenerate this file (or 'mage gen:all')
 */

export const PERMISSION_DEDUP_PAIRS: ReadonlyArray<{
  readonly read: string;
  readonly modify: string;
}> = [
  { read: 'AlertRead', modify: 'AlertModify' },
  { read: 'BulkUploadValidate', modify: 'BulkUpload' },
  { read: 'PolicyRead', modify: 'PolicyModify' },
  { read: 'ResourceRead', modify: 'ResourceModify' },
  { read: 'RuleRead', modify: 'RuleModify' },
  { read: 'UserRead', modify: 'UserModify' },
  { read: 'GeneralSettingsRead', modify: 'GeneralSettingsModify' },
  { read: 'CloudsecSourceRead', modify: 'CloudsecSourceModify' },
  { read: 'LogSourceRead', modify: 'LogSourceModify' },
  { read: 'LookupRead', modify: 'LookupModify' },
  { read: 'DestinationRead', modify: 'DestinationModify' },
  { read: 'DataAnalyticsRead', modify: 'DataAnalyticsModify' },
  { read: 'OrganizationAPITokenRead', modify: 'OrganizationAPITokenModify' },
  { read: 'ViewAIPrivateResponses', modify: 'ManageAIResponses' },
  { read: 'RunPantherAI', modify: 'AIRunAsModify' },
  { read: 'ViewAISkills', modify: 'ManageAISkills' },
  { read: 'ViewAISkills', modify: 'RunPantherAI' },
  { read: 'ViewScheduledPrompts', modify: 'ManageScheduledPrompts' },
  { read: 'ViewScheduledPrompts', modify: 'RunPantherAI' },
  { read: 'McpServerRead', modify: 'McpServerModify' },
];
